import * as React from "react";
import type { SVGProps } from "react";

const SvgUser = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={20}
    viewBox="0 0 18 20"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.682 10.757a.999.999 0 1 1 1.373 1.453C2.73 13.462 2 15.118 2 16.873V19c0 .55-.45 1-1 1s-1-.45-1-1v-2.127c0-2.31.952-4.483 2.682-6.116M9 0c2.824 0 5.122 2.305 5.122 5.138 0 .33-.033.665-.097.993a1 1 0 0 1-1.963-.383A3.135 3.135 0 0 0 9 2C7.279 2 5.879 3.408 5.879 5.138a3.13 3.13 0 0 0 3.095 3.134c.009 0 .017-.005.026-.005 4.962 0 9 3.86 9 8.606V19c0 .55-.45 1-1 1s-1-.45-1-1v-2.127c0-3.632-3.123-6.588-6.97-6.604-.01 0-.02.006-.03.006-2.824 0-5.121-2.305-5.121-5.137C3.879 2.305 6.176 0 8.999 0z"
    />
  </svg>
);
export default SvgUser;
